import Icon from '../components/Icon';

const Thermometer = Icon(
  'thermometer',
  <>
    <path d="M12.667 14.085V8.668a.667.667 0 0 0-1.334 0v5.417a2.667 2.667 0 1 0 1.334 0M12 18.003a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666m3.334-5.501V5.334a3.334 3.334 0 0 0-6.668 0v7.168a5.334 5.334 0 1 0 6.668 0M12 20.67a4 4 0 0 1-2.285-7.285.67.67 0 0 0 .285-.55V5.334a2 2 0 0 1 4 0v7.501a.67.67 0 0 0 .285.547A4 4 0 0 1 12 20.67" />
  </>
);

export default Thermometer;
